import { render, staticRenderFns } from "./CallCopyC.vue?vue&type=template&id=44be60f8&"
import script from "./CallCopyC.vue?vue&type=script&lang=js&"
export * from "./CallCopyC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports